import React from 'react';
import CrossRoad from "../UI/Crossroad";
const CrossRoad_11FBlue_11CBlack = () => <CrossRoad coords="2214.000000, 614.000000"/>;
export default CrossRoad_11FBlue_11CBlack;
